// Compatible for babel-plugin-import
/* istanbul ignore next */
export default {};
